import React from 'react';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import Chip from '@mui/material/Chip';
import { ROLE_OPTIONS, roleLabel } from '../helpers/roles';

// The role picker, shared by the two places roles are chosen: the create dialog
// and the editor on the show page. Written once because the two had been copied
// from each other, and a permission control is the wrong thing to let drift into
// two versions that disagree about what can be selected.
//
// MUI's multi-select hands back a comma-joined string on change in one of its
// internal paths, so the split is handled here rather than in every caller.
const toArray = value => (typeof value === 'string' ? value.split(',') : value);

const RoleMultiSelect = ({ value, onChange, label, labelId }) => (
    <FormControl fullWidth margin="normal">
        <InputLabel id={labelId}>{label}</InputLabel>
        <Select
            labelId={labelId}
            multiple
            value={value}
            onChange={ev => onChange(toArray(ev.target.value))}
            renderValue={selected => (
                selected.length
                    ? selected.map(role => <Chip key={role} label={roleLabel(role)} size="small" />)
                    : 'none'
            )}
        >
            {ROLE_OPTIONS.map(option => (
                <MenuItem key={option.value} value={option.value}>
                    <Checkbox checked={value.indexOf(option.value) > -1} />
                    <ListItemText primary={option.label} secondary={option.description} />
                </MenuItem>
            ))}
        </Select>
    </FormControl>
);

export default RoleMultiSelect;
